/**
 * Returns today's date in PST as "YYYY-MM-DD".
 * - On localhost: add ?date=YYYY-MM-DD to the URL to test a specific date.
 * - Alternatively: set REACT_APP_DATE_OVERRIDE=YYYY-MM-DD in .env.local (requires dev server restart).
 */
export const getTodayInPST = () => {
  if (window.location.hostname === 'localhost') {
    const params = new URLSearchParams(window.location.search);
    const urlDate = params.get('date');
    if (urlDate && /^\d{4}-\d{2}-\d{2}$/.test(urlDate)) {
      return urlDate;
    }
  }
  if (process.env.REACT_APP_DATE_OVERRIDE) {
    return process.env.REACT_APP_DATE_OVERRIDE;
  }
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(new Date());
};

export const getYesterdayInPST = () => {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(yesterday);
};

export const formatTodayDate = () => {
  const today = new Date();
  return today.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export const getTimeUntilNextPSTMidnight = () => {
  const now = new Date();
  const nowUTC = new Date(
    now.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
  );
  const nextMidnight = new Date(nowUTC);
  nextMidnight.setHours(24, 0, 0, 0);
  const diff = nextMidnight - nowUTC;
  return {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
};
